import { Outlet, redirect, RouteObject } from 'react-router-dom';

import { getProduct, Products } from '../../data/products';
import Product from './Product';

export const PRODUCTS_PATH = '/products';

export const productsRoute: RouteObject = {
  path: PRODUCTS_PATH,
  element: <Outlet />,
  children: [
    {
      path: ':productSlug',
      element: <Product />,
      loader: ({ params }) =>
        getProduct(params.productSlug) ?? redirect(PRODUCTS_PATH),
    },
    {
      path: 'recommended/:productSlug',
      element: <Product recommended={true} />,
      loader: ({ params }) =>
        getProduct(params.productSlug) ?? redirect(PRODUCTS_PATH),
    },
    {
      index: true,
      loader: () => redirect(productRoute(Products.ViewPlus)),
    },
  ],
};

export const productRoute = (
  slug: Products,
  { recommended }: { recommended?: boolean } = {}
) => `${recommended ? `${PRODUCTS_PATH}/recommended` : PRODUCTS_PATH}/${slug}`;
